import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { contractPortfolioApi, ContractPortfolio } from '@/lib/api/reports';

export function useContractPortfolio() {
  const [data, setData] = useState<ContractPortfolio | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      setData(await contractPortfolioApi.get());
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Erro ao carregar a carteira de contratos');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { data, isLoading, reload: load };
}
